import _ from 'lodash';
import safeParseUrl from './safeParseUrl';

const includesExtension = (url: string, extensions: string[] = []) => {
  const parsedUrl = safeParseUrl(url);
  if (parsedUrl) {
    const ext = _.last(parsedUrl.pathname.split('.'))?.toLowerCase();
    return ext && extensions.includes(ext);
  }
  return false;
};

export default includesExtension;
